import React from 'react';
import {BrowserRouter, Route, Routes,} from "react-router-dom";
import {Spin} from 'antd';
import {useQuery} from "react-query";
import {GetProfileConsole} from "../../../api/console";
import {ConsoleCreateProfile} from './CreateProfile';
import {
    AppController,
    AppCreateController,
    DeveloperIndexController,
    DeveloperPage,
    IndexController,
    InProgress,
    ReleaseController,
    ReleaseCreateController,
    StoreController,
    PublishReleaseController, EditAccountController, EditPageController
} from './controllers/index';


export const Console = (props) => {

    const ProfileConsole = useQuery('profile_console', GetProfileConsole, {
        retry: 2,
        retryDelay: 2500,
    });

    return (
        <Spin spinning={ProfileConsole.isLoading}>
            <BrowserRouter>
                <div className={`console console--container`}>
                    {(ProfileConsole.data && ProfileConsole?.data?.list.length === 0) && (
                        <ConsoleCreateProfile profile={ProfileConsole.data || {}}/>
                    )}
                    {(ProfileConsole.data && ProfileConsole?.data?.list.length > 0) && (
                        <ConsoleRouter profile={ProfileConsole.data || {}}/>
                    )}
                </div>
            </BrowserRouter>
        </Spin>
    );
}


export const ConsoleRouter = ({profile}) => {
    return (
        <Routes>
            <Route path={`/console`} exact element={<IndexController profile={profile}/>}/>
            <Route path={`/console/:developer_id`} element={<DeveloperPage profile={profile}/>}>

                <Route index element={<DeveloperIndexController profile={profile}/>}/>
                <Route path={`apps_create`} element={<AppCreateController profile={profile}/>}/>
                <Route path={`app/:app_id`} element={<AppController profile={profile}/>}/>
                <Route path={`app/:app_id/store`} element={<StoreController profile={profile}/>}/>
                <Route path={`app/:app_id/release`} element={<ReleaseController profile={profile}/>}/>
                <Route path={`app/:app_id/release/new`} element={<ReleaseCreateController profile={profile}/>}/>
                <Route path={`app/:app_id/release/:release_id`} element={<PublishReleaseController profile={profile}/>}/>

                <Route path={`app/:app_id/notifications`} element={<InProgress profile={profile}/>}/>
                <Route path={`app/:app_id/stats`} element={<InProgress profile={profile}/>}/>
                <Route path={`notifications`} element={<InProgress profile={profile}/>}/>
                <Route path={`users`} element={<InProgress profile={profile}/>}/>
                <Route path={`reports`} element={<InProgress profile={profile}/>}/>
                <Route path={`account`} element={<EditAccountController profile={profile}/>}/>
                <Route path={`page`} element={<EditPageController profile={profile}/>}/>

            </Route>
        </Routes>
    );
}


export default Console;